import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Accordion of questions and answers; the first item starts open.
 * faqs: [{ question, answer }]
 */
export const FaqSection = ({ id, eyebrow, title, subtitle, faqs, className = '' }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const headingId = `${id}-heading`;

  return (
    <section
      id={id}
      aria-labelledby={headingId}
      className={`scroll-mt-24 bg-white rounded-2xl border border-slate-200/90 shadow-sm p-5 sm:p-7 ${className}`}
    >
      {eyebrow && <p className="text-[11px] font-extrabold uppercase tracking-wider text-[#008080]">{eyebrow}</p>}
      <h2 id={headingId} className="mt-1 text-lg sm:text-xl font-extrabold text-slate-900 tracking-tight">
        {title}
      </h2>
      {subtitle && <p className="mt-1 text-xs sm:text-sm text-slate-500">{subtitle}</p>}

      <div className="mt-5 space-y-2.5">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `${id}-panel-${index}`;
          return (
            <div key={faq.question} className="rounded-xl border border-slate-200 overflow-hidden">
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
                aria-controls={panelId}
                className={`w-full flex items-center justify-between gap-3 px-4 py-3 text-left text-sm font-bold transition-colors ${
                  isOpen ? 'bg-teal-50/60 text-[#006666]' : 'text-slate-800 hover:bg-slate-50'
                }`}
              >
                {faq.question}
                <ChevronDown className={`w-4 h-4 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
              </button>
              {isOpen && (
                <p id={panelId} className="px-4 py-3 border-t border-slate-200 text-xs sm:text-sm text-slate-600 leading-relaxed">
                  {faq.answer}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FaqSection;
